"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const requestUtil_1 = require("../requestUtil");
const configurations_1 = require("../configurations");
const mfe_1 = __importDefault(require("../mfe"));
const getMultiLanguageFile = (subUrl) => __awaiter(void 0, void 0, void 0, function* () {
    if (subUrl.startsWith('/')) {
        subUrl = subUrl.substring(1);
    }
    const url = `${(0, configurations_1.getServer)().INTERWOVEN_SERVER}/${subUrl}`;
    console.log('stitcher---getMultiLanguageFile', url);
    try {
        return yield (0, requestUtil_1.fetchRequest)(url, 'GET', {}, null, false);
    }
    catch (err) {
        console.log('Error happen when getMultiLanguageFile:', err);
        console.log('This is the url when get multilanguage file and the error occurred :', subUrl);
        getMultiLanguageFileFromLocal(subUrl);
    }
});
const getMultiLanguageFileFromLocal = (subUrl) => __awaiter(void 0, void 0, void 0, function* () {
    const registerConfig = yield mfe_1.default.getRegisterMFEList();
    const { publicPath } = registerConfig.stitcher;
    const subUrls = subUrl.split('/');
    const subUrlLanguageMatch = subUrls[1];
    var subLanguageUrl = '';
    switch (subUrlLanguageMatch.toLowerCase()) {
        case 'en-us':
        case 'en-gb':
            subLanguageUrl = 'en-US/en_default.json';
            break;
        case 'ms-my':
            subLanguageUrl = 'ms-MY/ms_default.json';
            break;
        case 'zh-hk':
            subLanguageUrl = 'zh-HK/zh_hk_default.json';
            break;
        case 'zh-cn':
            subLanguageUrl = 'zh-CN/zh_default.json';
            break;
        default:
            subLanguageUrl = 'en-US/en_default.json';
            break;
    }
    console.log('subLanguageUrl:', subLanguageUrl);
    const url = `${publicPath}/${subLanguageUrl}`;
    console.log('stitcher---getLocalMultiLanguageFile', url);
    return (0, requestUtil_1.fetchRequest)(url, 'GET', {}, null, false);
});
exports.default = getMultiLanguageFile;
